/**
 * Copy for the /goodie landing page. Icons refer to keys in ./icons.jsx.
 * Trust statements only repeat claims that already exist on the site
 * (FAQ, hero badge, contact section, footer).
 */

export const goodieFeatures = [
  {
    icon: 'document',
    accent: 'orange',
    title: 'Dokumentation & Abrechnung',
    description:
      'Leistungen schnell dokumentieren und Abrechnung direkt mitdenken – inklusive intelligenter Regeln für BEMA, GOZ und weitere Abrechnungsbereiche.',
    featured: true,
  },
  {
    icon: 'clipboard',
    accent: 'blue',
    title: 'Digitale Anamnese',
    description:
      'Patienten füllen ihre Anamnese bequem digital aus – per Smartphone, QR-Code oder Tablet.',
  },
  {
    icon: 'calendar',
    accent: 'blue',
    title: 'Online-Termine',
    description:
      'Patienten können verfügbare Termine online buchen, ohne ständig in der Praxis anrufen zu müssen.',
  },
  {
    icon: 'bell',
    accent: 'orange',
    title: 'Recall',
    description:
      'Patienten automatisiert an wichtige Folgetermine und Recall-Intervalle erinnern.',
  },
  {
    icon: 'sparkles',
    accent: 'blue',
    title: 'KI-Unterstützung',
    description:
      'FOXI unterstützt das Praxisteam dabei, Dokumentation und administrative Abläufe effizienter zu erledigen.',
  },
];

export const goodieBenefits = [
  'Zahnbezogene Dokumentation',
  'Intelligente Abrechnungsregeln',
  'BEMA, GOZ, BEB und individuelle Leistungen',
];

/* `foxi: true` marks the steps FOXI takes care of. */
export const goodieWorkflow = [
  { icon: 'user', title: 'Patient', hint: 'Neu oder Bestandspatient' },
  {
    icon: 'clipboard',
    title: 'Digitale Anamnese',
    hint: 'Per Smartphone oder Tablet',
    foxi: true,
  },
  { icon: 'calendar', title: 'Termin', hint: 'Online gebucht', foxi: true },
  { icon: 'tooth', title: 'Behandlung', hint: 'Im Behandlungszimmer' },
  {
    icon: 'document',
    title: 'Dokumentation & Abrechnung',
    hint: 'In wenigen Klicks erledigt',
    foxi: true,
  },
  {
    icon: 'bell',
    title: 'Recall',
    hint: 'Automatische Erinnerung',
    foxi: true,
  },
];

export const goodieTrust = [
  {
    icon: 'server',
    title: 'Server in Deutschland',
    description:
      'Alle Daten werden DSGVO-konform auf zertifizierten Servern in Deutschland gespeichert.',
  },
  {
    icon: 'shield',
    title: 'Datenschutz im Fokus',
    description:
      'FOXI unterstützt moderne Datenschutz-Standards und wird DSGVO-orientiert weiterentwickelt.',
  },
  {
    icon: 'mapPin',
    title: 'Von Zahnärzten für Zahnärzte',
    description:
      'Entwickelt in Düsseldorf – mit dem Blick für die echten Abläufe in deutschen Zahnarztpraxen.',
  },
  {
    icon: 'tooth',
    title: 'BEMA, GOZ & BEB',
    description:
      'Die Abrechnungsregeln der deutschen Zahnmedizin sind direkt in FOXI integriert.',
  },
  {
    icon: 'users',
    title: 'Über 100 Praxen',
    description:
      'Zahnarztpraxen in ganz Deutschland arbeiten bereits täglich mit FOXI.',
  },
  {
    icon: 'link',
    title: 'Anbindung an Ihr PVS',
    description:
      'Dokumentation und Positionen lassen sich in gängige Praxisverwaltungssysteme übertragen.',
  },
];
